/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Export_ButtonInputs */

const en_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CCSL`)
};

const fr_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter CCSL`)
};

const de_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CCSL`)
};

const it_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta CCSL`)
};

const ru_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт CCSL`)
};

const es_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar CCSL`)
};

const zh_cn2_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口 CCSL`)
};

const ja_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL をエクスポート`)
};

const hi_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CCSL निर्यात करें`)
};

const pt_pt2_ccsl_export_export_button = /** @type {(inputs: Ccsl_Export_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar CCSL`)
};

/**
* | output |
* | --- |
* | "Export CCSL" |
*
* @param {Ccsl_Export_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_export_button = /** @type {((inputs?: Ccsl_Export_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_export_button(inputs)
	if (locale === "de") return de_ccsl_export_export_button(inputs)
	if (locale === "it") return it_ccsl_export_export_button(inputs)
	if (locale === "ru") return ru_ccsl_export_export_button(inputs)
	if (locale === "es") return es_ccsl_export_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_export_button(inputs)
	if (locale === "ja") return ja_ccsl_export_export_button(inputs)
	if (locale === "hi") return hi_ccsl_export_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_export_button(inputs)
	return en_ccsl_export_export_button(inputs)
});